import { call, put } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import api from 'src/services/api'

import { ClientNotifyCatch } from 'src/config/bugsnag'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'
import { ResponseDataRequests } from './types'
import * as Actions from './actions'

export function* getAgreement({
  payload: { options }
}: ReturnType<typeof Actions.getAgreement>) {
  try {
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.get,
      `/organizations/${
        options.agency_partner_id
      }/agreements?integration_type=PARTNER&page=${options.page || 1}`
    )

    if (response.ok) {
      const { agreements } = response.data
      yield put(Actions.getAgreementSuccess({ agreements }))
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.getAgreementFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getPartners', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.getAgreementFailure(message))
  }
}

export function* sendAgreement({
  payload: { agreements }
}: ReturnType<typeof Actions.sendAgreement>) {
  try {
    // const {
    //   partners,
    //   me: { user }
    // } = yield select((state: ApplicationState) => state)

    const responsePayload = { agreements }
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.post,
      `/organizations/${agreements[0].agency_partner_id}/agreements`,
      responsePayload
    )

    if (response.ok) {
      yield put(Actions.sendAgreementSuccess())
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.sendAgreementFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga sendPartner', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.sendAgreementFailure(message))
  }
}
